import { GlobalThemeOverrides } from 'naive-ui';

// app theme preset color
export const appThemeList: string[] = [
  '#2d8cf0',
  '#0960bd',
  '#0084f4',
  '#009688',
  '#536dfe',
  '#ff5c93',
  '#ee4f12',
  '#0096c7',
  '#9c27b0',
  '#ff9800',
  '#FF3D68',
  '#00C1D4',
  '#71EFA3',
  '#171010',
  '#78DEC7',
  '#1768AC',
  '#FB9300',
  '#FC5404',
];

const setting: {
  darkTheme: boolean;
  appTheme: string;
  appThemeList: string[];
  naiveuiTheme: GlobalThemeOverrides;
} = {
  //深色主题
  darkTheme: false,
  //系统主题色
  appTheme: '#172344',
  //系统内置主题色列表
  appThemeList,
  naiveuiTheme: {
    common: {
      inputColor: '#F2F3F5',
      primaryColor: '#172344',
      primaryColorHover: '#172344',
      primaryColorPressed: '#172344',
    },
    Menu: {
      borderRadius: '0',
      itemHeight: '50px',
      color: '#FFFFFFFF',
      // 选中颜色

      itemColorActive: '#375068',
      itemColorActiveInverted: '#375068',

      itemTextColorActiveInverted: '#fff',
      itemColorActiveCollapsed: 'linear-gradient(-90deg, #3E5B73 0%, #293A52 98%)',

      itemColorActiveCollapsedInverted: '#375068',
      // --n-item-color-active-hover
      itemTextColorChildActive: '#fff',
      itemTextColorChildActiveInverted: '#fff',
      itemTextColor: '#fff',
      itemTextColorInverted: '#fff',
      itemColorActiveHover: 'transparent',
      itemColorActiveHoverInverted: '#375068',
      // itemTextColor: 'rgba(255, 255, 255, 1)',
      itemTextColorHover: '#375068FF',
      // itemTextColorChildActive: '#375068FF',
      itemTextColorActive: '#375068FF',
    },
    Button: {
      borderRadiusLarge: '0',
      borderRadiusMedium: '0',
      borderRadiusSmall: '0',
      borderRadiusTiny: '0',
      // color: '#172344',
      // colorHover: '#172344',
      textColorText: '#172344',
      textColorTextHover: '#172344',
      // textColor: '#fff',
      // rippleColor: '#172344',
      // textColorHover: '#fff',
      // borderHover: '#172344',
    },
    Input: {
      borderRadius: '0',
      borderFocus: '1px solid #172344',
      loadingColor: '#172344',
      boxShadowFocus: '0px 0px 6px 0px rgba(23, 35, 68, .4)',
    },
    DatePicker: {
      itemBorderRadius: '0',
      panelBorderRadius: '0',
      scrollItemBorderRadius: '0',
    },
    Tabs: {
      tabColorSegment: '#172344',
      tabTextColorSegment: '#172344',
      tabTextColorActiveSegment: '#fff',
      tabTextColorHoverSegment: '#eee',
      tabTextColorHoverCard: '#172344',
      tabTextColorActiveCard: '#172344',
      tabBorderRadius: '0',
    },
    Spin: {
      color: '#172344',
      textColor: '#172344',
    },
  },
};

export default setting;
